import React, { useState, useRef, useEffect } from "react";
import Footer from "./Footer";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

function AdvisoryManagement1(props) {



    const [selectedValue, setSelectedValue] = useState("option1");


    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [isOpen1, setIsOpen1] = useState(false);
    const dropdownRef1 = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside1 = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside1);
        return () => document.removeEventListener("mousedown", handleClickOutside1);
    }, []);



    return (
        <>
            <div className="container-fluid mt-60px mb-5 pb-5">
                <div className="row pt-3">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="threshold-box p-3 ">
                            <h5>Advisory Management</h5>
                        </div>

                        <form>
                            <div
                                className="d-flex align-items-end gap-2 px-3"
                                style={{
                                    justifyContent: "space-between",
                                    flexWrap: "nowrap",
                                }}
                            >
                                {/* Country */}
                                <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                    <label className="form-label fw-semibold">Country</label>
                                    <select className="form-select">
                                        <option value="">Select Country</option>
                                        <option value="malawi">Malawi</option>
                                        <option value="zambia">Zambia</option>
                                        <option value="tanzania">Tanzania</option>
                                    </select>
                                </div>

                                {/* Region */}
                                <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                    <label className="form-label fw-semibold">Region</label>
                                    <select className="form-select">
                                        <option value="">Select Region</option>
                                        <option value="north">Northern</option>
                                        <option value="south">Southern</option>
                                        <option value="east">Eastern</option>
                                    </select>
                                </div>

                                {/* District */}
                                <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                    <label className="form-label fw-semibold">District</label>
                                    <select className="form-select">
                                        <option value="">Select District</option>
                                        <option value="lilongwe">Lilongwe</option>
                                        <option value="blantyre">Blantyre</option>
                                        <option value="mzuzu">Mzuzu</option>
                                    </select>
                                </div>

                                {/* Camp */}
                                <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                    <label className="form-label fw-semibold">Camp</label>
                                    <select className="form-select">
                                        <option value="">Select Camp</option>
                                        <option value="camp1">Camp 1</option>
                                        <option value="camp2">Camp 2</option>
                                        <option value="camp3">Camp 3</option>
                                    </select>
                                </div>

                                {/* Species */}
                                <div style={{ flex: "1 1 0", minWidth: 0 }}>
                                    <label className="form-label fw-semibold">Species</label>
                                    <select className="form-select">
                                        <option value="">Select Species</option>
                                        <option value="tilapia">Tilapia</option>
                                        <option value="catfish">Catfish</option>
                                        <option value="carp">Carp</option>
                                    </select>
                                </div>

                                {/* Buttons */}
                                <div className="d-flex gap-2" style={{ flex: "0 0 auto" }}>
                                    <button type="button" className="btn btn-applyNew px-3">
                                        Apply
                                    </button>
                                    <button type="button" className="btn btn-applyNew px-3">
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="table-responsive mt-5 px-3">
                            <table className="table tbl_new tdColor table-bordered">
                                <thead>
                                    <tr>
                                        <th>Camp</th>
                                        <td>Camp 2</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Species</th>
                                        <td>Oreochromis macrochir</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <th>Dates</th>
                                        <td>09/10/2025</td>
                                        <td>10/10/2025</td>
                                        <td>11/10/2025</td>
                                        <td>12/10/2025</td>
                                        <td>13/10/2025</td>
                                        <td>14/10/2025</td>
                                        <td>15/10/2025</td>
                                    </tr>

                                    <tr>
                                        <th>Max Air Temp</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                    <tr>
                                        <th>Min Air Temp</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                    <tr>
                                        <th>Pond Temp</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                    <tr>
                                        <th>Max Pond Temp</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                    <tr>
                                        <th>Min Pond Temp</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                    <tr>
                                        <th>Risk Level</th>
                                        <td><div className="mb-1">High <img alt="" src="./assets/images/error.png" /></div></td>
                                        <td><div className="mb-1">High <img alt="" src="./assets/images/error.png" /></div></td>
                                        <td>Normal</td>
                                        <td>Normal</td>
                                        <td>Normal</td>
                                        <td>Normal</td>
                                        <td>Normal</td>
                                    </tr>

                                    <tr>
                                        <th>Advisory</th>
                                        <td><a href="#">Click to View</a></td>
                                        <td><a href="#">Click to View</a></td>
                                        <td><a href="#">Click to View</a></td>
                                        <td><a href="#">Click to View</a></td>
                                        <td><a href="#">Click to View</a></td>
                                        <td><a href="#">Click to View</a></td>
                                        <td><a href="#">Click to View</a></td>
                                    </tr>

                                    <tr>
                                        <th>Sent Advisory</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                     <tr>
                                        <th>Received Advisory</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                     <tr>
                                        <th>Failed to deliver</th>
                                        <td>40</td>
                                        <td>40</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                        <td>20</td>
                                    </tr>

                                </thead>
                            </table>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="lightBoxNew">
                            <h4>Weekly summary</h4>
                            <div className="scrollBox" style={{ height: '340px', overflowY: 'hidden' }}>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="lightBoxNew">
                            <h4>Today Advisory</h4>
                            <div key="inline-radio" className="mb-3">
                                <Form.Check
                                    inline
                                    label="English"
                                    name="group1"
                                    type="radio"
                                    id="inline-radio-1"
                                    value="option1"
                                    checked={selectedValue === "option1"}
                                    onChange={(e) => setSelectedValue(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    label="Bemba"
                                    name="group1"
                                    type="radio"
                                    id="inline-radio-2"
                                    value="option2"
                                    checked={selectedValue === "option2"}
                                    onChange={(e) => setSelectedValue(e.target.value)}
                                />
                            </div>

                            <div className="scrollBox" style={{ height: '300px', overflowY: 'scroll' }}>

                                <p className="mb-0"> --------------EMERGENCY!!!---------------------t</p>
                                <p className="mb-0"> Water temperature is reaching 12°C!!!</p>
                                <p className="mb-0"> Water temperature is predicted to increase to high-risk levels over the next 8 to 12 hours.</p>
                                <p className="mb-0"> Water temperature that is too high or too low affects fish health. Water temperature affects key parameters that can
                                    also affect fish health, such as dissolved Oxygen, pH, ammonia, nitrite.</p>
                                <p className="mb-0"> --------------MONITORING:--------------------</p>
                                <p className="mb-0"> Monitor the following parameters:</p>
                                <p className="mb-0">  Water temperature, air temperature, Dissolved Oxygen (DO), pH, ammonia, nitrite, and fish behaviors.</p>
                                <p className="mb-0"> FREQUENCY:</p>
                                <p className="mb-0"> Every 4 hours during the day and night - 06h00, 10h00, 14h00, 18h00, 22h00, 02h00)</p>

                                <p className="mb-0"> --------------MITIGATION:--------------------</p>
                                <p className="mb-0"> FLUSHING: If any measurements exceed the below values, PLEASE add freshwater from the
                                    water source, continue to monitor at the outlet; once a parameter has decreased below
                                    the level below, stop adding water.</p>

                                <p className="mb-0">FEEDING/FERTILIZING: If any measurements exceed the below values, PLEASE reduce the number
                                    of feeds by 1 and also feed slowly until fish stop feeding.</p>

                                <p className="mb-0">BEHAVIOR: If fish display any stress-related behavior such as gasping for air at the
                                    surface, swimming or lying on the side, or floating still at the surface but still moving,
                                    PLEASE prepare to harvest fish or move them to another pond with temperature, DO, pH,
                                    ammonia, and nitrite in safe limits.</p>


                                <p className="mb-0">Temperature &lt; 14°C</p>
                                <p className="mb-0">DO  &lt; 6 mg/l</p>
                                <p className="mb-0">pH increasing to 9 or more</p>
                                <p className="mb-0">pH decreasing to 7 or less</p>
                                <p className="mb-0"> Ammonia XXX</p>
                                <p className="mb-0"> Nitrite XXX</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <Footer />
        </>
    )
}

export default AdvisoryManagement1